<template>
  <div>
    <el-upload
      :action="baseUrl + action"
      drag
      multiple
      class="upload-demo"
      :headers="headers"
      :on-remove="handleRemove"
      :file-list="fileList"
      :on-success="handleSuccess"
      :on-error="handleError"
      :before-upload="beforeUpload"
      list-type="picture"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text" v-loading="loading">
        将文件拖到此处，或<em>点击上传</em>
      </div>
    </el-upload>
  </div>
</template>

<script>
import { Message } from "element-ui";
import fileImg from "@/assets/image/fileImg.png";
export default {
  props: {
    action: {
      type: String,
      required: false,
    },
    fileTypes: {
      type: Array,
      default: null,
    },
    maxSize: {
      type: Number,
      default: null,
    },
    showLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    myFileList: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.setHeaders();
  },
  computed: {
    fileList: {
      get() {
        return this.myFileList;
      },
      set(val) {
        this.$emit("update:myFileList", val);
      },
    },
  },
  data() {
    return {
      loading: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      dialogImageUrl: "",
      dialogVisible: false,
      defaultIcon: "el-icon-document",
    };
  },
  methods: {
    // 设置请求头
    setHeaders() {
      // 上传请求头设置
      const headers = {};
      // 登录的token
      headers.accessToken = sessionStorage.getItem("accessToken");
      this.headers = headers;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.loading =
        this.fileList.filter((item) => !item.response).length > 0;
    },
    handleSuccess(response, file, fileList) {
      debugger;
      const updatedFile = fileList.find((item) => item.uid === file.uid);
      if (updatedFile?.response && updatedFile?.response.code !== 200) {
        Message.error(updatedFile?.response.message);
      }
      updatedFile.response = response.data;
      updatedFile.size = this.formatSize(file.size);
      this.fileList = fileList
        .filter((item) => item.response)
        .map((item) => {
          return {
            ...item,
            url:
              !item.raw || item.raw.type.includes("image") ? item.url : fileImg,
          };
        });
      this.loading = this.fileList.filter((item) => !item.response).length > 0;
    },
    handleError(err, file, fileList) {
      this.fileList = fileList.filter((item) => item.uid !== file.uid);
      this.loading = this.fileList.filter((item) => !item.response).length > 0;
      Message.error("上传失败");
      console.error("Upload error:", err);
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt500K = file.size / 1024 / 1024 < 0.5;

      // if (!isJPG && !isPNG) {
      //   this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      //   return false;
      // }
      if (!isLt500K) {
        // this.$message.error("上传图片大小不能超过 500KB!");
        // return false;
      }
      this.loading = true;
      return true;
    },
    isImage(file) {
      return file.type.startsWith("image/");
    },
    formatSize(size) {
      return (size / 1024).toFixed(2) + " KB";
    },
  },
};
</script>

<style>
.image-preview {
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.el-upload-list--picture .el-upload-list__item-thumbnail {
  object-fit: contain;
}
</style>
